import { useTheme as useAppTheme } from "../../contexts/ThemeContext";
import React from 'react';
import { useState } from "react";

import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import Box from "@mui/material/Box";
import { useEffect, useRef } from "react";
import { Chip, TextField, FormControl, Paper, TablePagination } from "@mui/material";
import DateFilter from "./DateFilter.jsx";
import MemberAvatar from './MemberAvatar';
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import json2mq from "json2mq";
import { useNavigate } from "react-router-dom";
import {
  retrieveExpiredYearlyMembership,
  MemberExpireDUserauto
} from "../Apihelper/DueUserApi.js";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    borderBottom: 'none',
    padding: '8px 12px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px',
      fontSize: '0.875rem',
    },
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: '8px 10px',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    verticalAlign: 'top',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px',
      fontSize: '0.813rem',
    },
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f9f9f9',
  },
  '&:hover': {
    backgroundColor: 'rgba(31, 122, 84, 0.08)',
    cursor: 'pointer',
  },
  '& .MuiTableCell-root': {
    minWidth: 0,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const YearlyMembershipExpired = () => {
  const navigate = useNavigate();
  const { colors: appColors } = useAppTheme();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [fetchdatarow, setetchdatarow] = useState([]);
  const [datelist, setDatelist] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [todate, settodate] = useState("");
  const dateRef = useRef();

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );

  useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      navigate('/');
    }
  }, []);

  const fetchData = async (value = '', newPage = 0, newRowsPerPage = rowsPerPage) => {
    setLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const searchText = value;
      const limit = newRowsPerPage;
      const index = newPage * newRowsPerPage;
      const res = await retrieveExpiredYearlyMembership(userToken, userId, searchText, limit, index, datelist,
        fromDate,
        todate);

      if (res.code == "200") {
        const data = res.data;
        setetchdatarow(data);
        setLoading(false);
        const total = res.total_count ?? res.recordsTotal ?? res.recordsFiltered ?? res.total ?? null;
        if (total !== null) {
          setTotalCount(total);
        } else {
          setTotalCount(
            data.length < newRowsPerPage
              ? newPage * newRowsPerPage + data.length
              : (newPage + 1) * newRowsPerPage + 1
          );
        }
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchData('', newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchData('', 0, newRowsPerPage);
  };

  const handleSearchChange = (event, value) => {
    const searchText = value || '';
    setPage(0);
    fetchData(searchText, 0, rowsPerPage);
  };

  const handleInputChange = async (value) => {
    if (value.length >= 3) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id;
        const res = await MemberExpireDUserauto(userToken, userId, value);

        if (res.code == "200") {
          const dataArray = Object.values(res.data);
          if (Array.isArray(dataArray)) {
            const names = dataArray.map(item => item.search_text);
            setOptions(names);
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleCardPress = async (member_id) => {
    try {
      navigate('/memberdetails', {
        state: {
          id: member_id,
          random_no: Math.random(),
        },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleApplydatecustom = async ({ fromDateval, toDateval, value = '' }) => {
    settodate(toDateval);
    setFromDate(fromDateval);
    setLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const searchText = value;
      const limit = rowsPerPage;
      const index = 0;

      const data = await retrieveExpiredYearlyMembership(
        userToken,
        userId,
        searchText,
        limit,
        index,
        datelist,
        fromDateval,
        toDateval,
      );
      if (data.code == "200") {
        setetchdatarow(data.data);
        setLoading(false);
        setPage(0);
        const total = data.total_count ?? data.recordsTotal ?? data.recordsFiltered ?? data.total ?? null;
        if (total !== null) {
          setTotalCount(total);
        } else {
          setTotalCount(
            data.data.length < rowsPerPage
              ? data.data.length
              : rowsPerPage + 1
          );
        }
      } else {
        setetchdatarow([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const handleApplydate = async (selectedValue, value = '') => {
    setDatelist(selectedValue);
    setLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const searchText = value;
      const limit = rowsPerPage;
      const index = 0;
      const data = await retrieveExpiredYearlyMembership(
        userToken,
        userId,
        searchText,
        limit,
        index,
        selectedValue,
        "",
        "",
      );
      if (data.code == "200") {
        setLoading(false);
        setetchdatarow(data.data);
        setPage(0);
        const total = data.total_count ?? data.recordsTotal ?? data.recordsFiltered ?? data.total ?? null;
        if (total !== null) {
          setTotalCount(total);
        } else {
          setTotalCount(
            data.data.length < rowsPerPage
              ? data.data.length
              : rowsPerPage + 1
          );
        }
      } else {
        setetchdatarow([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  return (
    <div>
      <Box sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2,
        mb: 2
      }}>
        <Box sx={{ flex: 1, mt: 1 }}>
          <Autocomplete
            freeSolo
            options={options}
            onInputChange={(event, value) => handleInputChange(value)}
            onChange={(event, value) => handleSearchChange(event, value)}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                fullWidth
                label="Search"
                InputProps={{
                  ...params.InputProps,
                  type: 'search',
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#fff',
                  }
                }}
              />
            )}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <FormControl>
            <DateFilter
              ref={dateRef}
              onApplycustomdate={handleApplydatecustom}
              onApply={handleApplydate}
            />
          </FormControl>
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          width: '100%',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px',
          overflowX: 'auto',
          mb: 2
        }}
      >
        <Table sx={{ width: '100%', minWidth: 700 }}>
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ width: 36, whiteSpace: 'nowrap' }}>#</StyledTableCell>
              <StyledTableCell sx={{ whiteSpace: 'nowrap' }}>MEMBER</StyledTableCell>
              <StyledTableCell sx={{ whiteSpace: 'nowrap', display: { xs: 'none', sm: 'table-cell' } }}>PHONE</StyledTableCell>
              <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>EMAIL</StyledTableCell>
              <StyledTableCell sx={{ whiteSpace: 'nowrap' }}>PACKAGE AMOUNT</StyledTableCell>
              <StyledTableCell sx={{ whiteSpace: 'nowrap' }}>END DATE</StyledTableCell>
              <StyledTableCell sx={{ whiteSpace: 'nowrap' }}>EXPIRED</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? Array.from({ length: rowsPerPage }).map((_, i) => (
              <TableRow key={i}>
                <TableCell><Skeleton width={20} /></TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Skeleton variant="circular" width={34} height={34} />
                    <Box><Skeleton width={110} /><Skeleton width={80} height={10} /></Box>
                  </Box>
                </TableCell>
                <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}><Skeleton width={90} /></TableCell>
                <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}><Skeleton width={140} /></TableCell>
                <TableCell><Skeleton width={70} /></TableCell>
                <TableCell><Skeleton width={80} /></TableCell>
                <TableCell><Skeleton width={60} /></TableCell>
              </TableRow>
            )) : fetchdatarow.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4, color: '#9ca3af' }}>
                  No expired yearly memberships found.
                </TableCell>
              </TableRow>
            ) : fetchdatarow.map((row, index) => (
              <StyledTableRow key={row.yearly_package_id ?? index}>
                <TableCell sx={{ color: '#9ca3af', fontSize: 11 }}>{page * rowsPerPage + index + 1}</TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <MemberAvatar image={row.image} name={row.name} size={34} />
                    <Box>
                      <Typography
                        onClick={() => handleCardPress(row.member_id)}
                        sx={{ fontSize: 13, fontWeight: 600, color: appColors.leaf, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                      >
                        {row.name}
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: '#9ca3af' }}>{row.membership_number}</Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell sx={{ fontSize: 13, display: { xs: 'none', sm: 'table-cell' } }}>{row.phone}</TableCell>
                <TableCell sx={{ fontSize: 13, display: { xs: 'none', md: 'table-cell' } }}>{row.email}</TableCell>
                <TableCell sx={{ fontSize: 13 }}>₹{row.package_amount}</TableCell>
                <TableCell sx={{ fontSize: 13, whiteSpace: 'nowrap' }}>{row.end_date}</TableCell>
                <TableCell>
                  <Chip
                    label={`${row.days_expired}d ago`}
                    size="small"
                    sx={{ fontSize: 11, height: 22, bgcolor: '#fee2e2', color: '#dc2626', fontWeight: 600 }}
                  />
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10, 20, 50]}
        onRowsPerPageChange={handleChangeRowsPerPage}
        showFirstButton
        showLastButton
        sx={{ '& .MuiTablePagination-actions': { mr: 8 } }}
        labelDisplayedRows={({ page: p, count }) =>
          `Page ${p + 1} of ${Math.ceil(count / rowsPerPage)}  |  Total: ${count} records`
        }
      />
    </div>
  );
};

export default YearlyMembershipExpired;
